import { render } from "./UnitsList.vue?vue&type=template&id=70153428&scoped=true"
import script from "./UnitsList.vue?vue&type=script&lang=js"
export * from "./UnitsList.vue?vue&type=script&lang=js"

import "./UnitsList.vue?vue&type=style&index=0&id=70153428&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70153428"]])

export default __exports__